<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Alunos</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Alunos',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="$check('Student', 'POST')" id="btnNew" type="button" color="primary" elevation="0"
                            to="/alunos/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col>
                                    <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name" hide-details
                                        outlined></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field dense id="email" label="Email" v-model="dataList.filter.email" hide-details
                                        outlined></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="table-card-title">Alunos</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum aluno foi encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.email`]="{ item }">
                                {{ item.email && item.email ? item.email : 'N/A' }}
                            </template>

                            <template v-slot:[`item.exit_status`]="{ item }">
                                <v-chip v-if="exitBlocked(item)" small label color="warning" text-color="#7c4a00">
                                    <v-icon left small>mdi-alert-outline</v-icon>
                                    {{ exitBlockLabel(item) }}
                                </v-chip>
                                <span v-else class="exit-enabled-label">Ativo</span>
                            </template>

                            <template v-slot:[`item.name`]="{ item }">
                                <div class="student-cell">
                                    <v-avatar class="student-avatar" size="40">
                                        <v-img v-if="studentImage(item)" :src="studentImage(item)"
                                            :alt="`Foto de ${item.name || 'aluno'}`"
                                            @error="markImageAsFailed(item)"></v-img>
                                        <span v-else>{{ studentInitials(item) }}</span>
                                    </v-avatar>
                                    <div class="student-info">
                                        <span class="student-name">{{ item.name && item.name ? item.name : 'N/A' }}</span>
                                        <small v-if="item.registration">{{ item.registration }}</small>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">
                                    <v-icon v-if="$check('Student', 'GET')" @click="summaryItem(item)" size="large"
                                        class="me-2">
                                        mdi-eye-outline
                                    </v-icon>

                                    <v-icon v-if="$check('Student', 'PATCH')" @click="viewItem(item)" size="large"
                                        class="me-2">
                                        mdi-pencil-outline
                                    </v-icon>

                                    <v-icon v-if="$check('Student', 'DELETE')" @click="deleteItem(item)" size="large"
                                        class="me-2">
                                        mdi-delete
                                    </v-icon>
                                </v-row>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"

Vue.use(VueLodash, { lodash: _ })

export default {
    name: "StudentList",

    data: () => ({
        dataset: {
            data: {}
        },
        imageErrors: {},
        dataList: {
            filter: {
                name: "",
                email: "",
            },
            headers: [
                { text: "Aluno", value: "name" },
                { text: "Email", value: "email" },
                { text: "CHEGUEI", value: "exit_status" },
                { text: "Criado em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {
        this.load();
    },

    methods: {

        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load(true);
        },

        getColorByStatus(status) {
            switch (status) {
                case 0:
                    return 'warning'
                case 1:
                    return 'accent'
                case 2:
                    return 'error'
                default:
                    break;
            }
        },

        studentImage(item) {
            if (!item || !item.document_url || this.imageErrors[item.id]) return null;

            return item.document_url;
        },

        markImageAsFailed(item) {
            if (!item || !item.id) return;

            this.$set(this.imageErrors, item.id, true);
        },

        studentInitials(item) {
            const name = item && item.name ? item.name : "Aluno";
            const parts = name.trim().split(/\s+/).filter(Boolean);
            const initials = parts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join("");

            return initials || "A";
        },

        exitPreference(item) {
            return item && (item.exitPreference || item.exit_preference) || null;
        },

        exitBlocked(item) {
            const preference = this.exitPreference(item);
            return preference && (preference.block_scope !== "none" || preference.cheguei_enabled_override === false);
        },

        exitBlockLabel(item) {
            const preference = this.exitPreference(item);
            if (!preference) return "Ativo";
            if (preference.block_scope === "school_transport_only") return "Transporte bloqueado";
            return "Liberação desabilitada";
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        async load() {

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.size;

            try {
                const result = await axios.get('/api/v1/students', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        viewItem(item) {
            this.$router.push(`alunos/${item.id}`);
        },

        summaryItem(item) {
            this.$router.push(`alunos/${item.id}/resumo`);
        },

        async deleteItem(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir Aluno',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                const result = await axios.delete(`/api/v1/students/${item.id}`)

                this.$dialog.notify.info("Aluno excluído com sucesso", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            } finally {
                this.dataList.loading = false;
            }

        },
    },
};
</script>

<style scoped>
.exit-enabled-label { color: #16855b; font-size: 12px; font-weight: 750; }
</style>

<style scoped lang="scss">
.student-cell {
    display: flex;
    align-items: center;
    min-height: 48px;
    gap: 12px;
}

.student-avatar {
    flex: 0 0 auto;
    border: 1px solid rgba(15, 23, 42, 0.08);
    background: #eaf2ff;
    color: #0b63ce;
    font-size: 13px;
    font-weight: 700;
}

.student-info {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 2px;
}

.student-name {
    color: #17233d;
    font-weight: 600;
    line-height: 1.2;
}

.student-info small {
    color: #718198;
    font-size: 11px;
    line-height: 1.2;
}
</style>
